module.exports = __webpack_public_path__ + "img/edicion.196f5331.png";